import {useEffect, useState} from 'react'
import {SlctOption} from 'module/Slct/type/SlctType'
import {ByValueCache} from 'module/Slct/type/ByValueCache'

interface Args<ModelType extends object | void, ValueType extends string | number> {
	byValueCache?: ByValueCache<ValueType>
	optionsUnfiltered: SlctOption<ModelType, ValueType>[]
}

export function useSlctByValue<ModelType extends object | void, ValueType extends string | number>({byValueCache, optionsUnfiltered}: Args<ModelType, ValueType>) {
	const [byValue, setByValue] = useState({} as ByValueCache<ValueType>)
	useEffect(() => {
		if (byValueCache) return;
		setByValue(optionsUnfiltered.reduce((ret, o) => {
			if (!o || !o.value && o.value !== 0) return ret
			ret[o.value] = o
			return ret
		}, {...byValue} as ByValueCache<ValueType>))
	}, [optionsUnfiltered])
	if (byValueCache) return byValueCache
	return byValue
}